@if (hasJWTInfo) {
  <div  class="registration-container">
    <div class="editsubtitle">Register this Network Controller in two simple steps:</div>
    <div class="steptext">
      <div class="step">1</div>
      Download Your Enrollment Token
    </div>
    <div class="row download">
      @if (!jwtExpired) {
        <div (click)="downloadKey()" class="downloadButton">
          <div class="DownloadKey"></div>
          <div>DOWNLOAD ENROLLMENT TOKEN</div>
          <div class="TapToDownload"></div>
        </div>
      }
      @if (!jwtExpired && expiration) {
        <div
          class="label row"
          style="text-align: center; color: red; padding: 0.625rem"
          >
          Expires {{ jwtExpiration }}
        </div>
      }
    </div>
    @if (!jwtExpired) {
      <div
        class="label row"
        style="text-align: center; margin-top: 0.625rem; margin-bottom: 0.3125rem"
        >
        OR
      </div>
    }
    <div class="row download">
      @if (!jwtExpired) {
        <div (click)="copyKey()" class="downloadButton">
          <div class="DownloadKey"></div>
          <div>COPY ENROLLMENT TOKEN</div>
          <div class="TapToDownload"></div>
        </div>
      }
      @if (!jwtExpired && expiration) {
        <div
          class="label row"
          style="text-align: center; color: red; padding: 0.625rem"
          >
          Expires {{ jwtExpiration }}
        </div>
      }
    </div>
    <div class="steptext">
      <div class="step">2</div>
      Enrollment Instructions <span class="note">Click to Copy</span>
    </div>
    <div
      (click)="copyEnrollmentInstructions()"
      class="code row enrollment-instructions-container"
      matTooltip="Click to copy instructions to clipboard"
      matTooltipPosition="below"
      matTooltipShowDelay="500"
      >
      <code>
        curl -sSLf https://get.openziti.io/tun/scripts/install-ubuntu.bash | bash <br>
        sudo systemctl enable --now ziti-edge-tunnel.service <br>
        sudo ziti-edge-tunnel add --identity identityFileName --jwt {{this.jwt}} <br>
      </code>
    </div>
  </div>
}